import { LinearGradient } from 'expo-linear-gradient'
import { useMemo, type FC, type ReactNode } from 'react'
import { useWindowDimensions, type ColorValue } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { COLOR_BRAND_BLUE_400, COLOR_BRAND_PURPLE_500, HEADER_HEIGHT } from '@/lib'

const gradientColors: [ColorValue, ColorValue, ...ColorValue[]] = [
  COLOR_BRAND_BLUE_400,
  COLOR_BRAND_BLUE_400,
  COLOR_BRAND_PURPLE_500
]

export interface BrandOffsetGradientViewProps {
  children: ReactNode
}

export const BrandOffsetGradientView: FC<BrandOffsetGradientViewProps> = ({ children }) => {
  const dimensions = useWindowDimensions()
  const insets = useSafeAreaInsets()

  return (
    <LinearGradient
      className='flex-1'
      colors={gradientColors}
      locations={useMemo<[number, number, ...number[]]>(() => {
        return [0, (HEADER_HEIGHT + insets.top) / Math.max(dimensions.height || 0, 1), 1]
      }, [dimensions.height, insets.top])}
    >
      {children}
    </LinearGradient>
  )
}
